import React from 'react';
import { Settings } from 'lucide-react';

const BackgroundControls = ({
  onShowBackgroundSettings
}) => {
  return (
    <div className="sidebar-card">
      <h4 className="section-title">背景自定义</h4>
      
      <div className="flex flex-col gap-3">
        <button 
          className="btn btn-primary"
          onClick={onShowBackgroundSettings}
        >
          <Settings size={16} className="mr-2" />
          背景设置
        </button>
      </div>
    </div>
  );
};

export default BackgroundControls;
